import React from "react";
import { Marker } from "react-google-maps";

import Partner from "../../types/Partner";
import InfoWindowComponent from "../infoWindow/InfoWindowComponent";

interface MarkerComponentProps {
  partners: Partner[];
  openInfoWindow: any;
  handleMarkerClick(partner: Partner): void;
}

const MarkerComponent = (props: MarkerComponentProps) => {
  const { partners, handleMarkerClick, openInfoWindow } = props;

  return (
    <>
      {partners &&
        partners.map(partner => {
          return (
            <Marker
              key={partner.id}
              icon="/modules/custom/custom_react_maps/img/marker.svg"
              position={{
                lat: +partner.lat,
                lng: +partner.lng
              }}
              onClick={() => handleMarkerClick(partner)}
            >
              {openInfoWindow[partner.id] && (
                <InfoWindowComponent partner={partner} />
              )}
            </Marker>
          );
        })}
    </>
  );
};

export default MarkerComponent;
